export enum ItemState {
  None = 0,
  Locked = 1,
  Tracked = 2,
  Masterwork = 4,
  Crafted = 8,
  HighlightedObjective = 16,
}
